module.exports = __webpack_public_path__ + "static/media/Mockup_casino_slot--desktop.906594bd.png";